"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

var _defineProperty = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/defineProperty");

require("core-js/modules/es6.object.define-property");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dispatchNativeEvent = exports.dispatchUpdatedChange = exports.dispatchOnInput = exports.dispatchOnChange = void 0;

var setNativeValue = function setNativeValue(element, value) {
  var _ref = Object.getOwnPropertyDescriptor(element, 'value') || {},
      valueSetter = _ref.set;

  var prototype = Object.getPrototypeOf(element);

  var _ref2 = Object.getOwnPropertyDescriptor(prototype, 'value') || {},
      prototypeValueSetter = _ref2.set;

  if (prototypeValueSetter && valueSetter !== prototypeValueSetter) {
    prototypeValueSetter.call(element, value);
  } else if (valueSetter) {
    valueSetter.call(element, value);
  } else {
    throw new Error('The given element does not have a value setter');
  }
};

var dispatchOnChange = function dispatchOnChange(element, value) {
  setNativeValue(element, value);
  var event = new Event('change', {
    bubbles: true,
    cancelable: false
  });
  element.dispatchEvent(event);
};

exports.dispatchOnChange = dispatchOnChange;

var dispatchOnInput = function dispatchOnInput(element, value) {
  setNativeValue(element, value);
  var event = new Event('input', {
    bubbles: true,
    cancelable: false
  });
  element.dispatchEvent(event);
};

exports.dispatchOnInput = dispatchOnInput;

var dispatchUpdatedChange = function dispatchUpdatedChange(event, value, callback) {
  var updatedEvent = _objectSpread({}, event, {
    target: _objectSpread({}, event.target, {
      value: value
    })
  });

  callback == null ? void 0 : callback(updatedEvent);
};

exports.dispatchUpdatedChange = dispatchUpdatedChange;

var dispatchNativeEvent = function dispatchNativeEvent(event, callback) {
  if (typeof event.persist === 'function') event.persist();
  callback == null ? void 0 : callback(event);
};

exports.dispatchNativeEvent = dispatchNativeEvent;